export default function fx(to, from) {
  return to * (1 / from);
}
